import { Route, Routes } from "react-router-dom";
import "./App.css";
import { HomePage } from "./pages/HomePage/HomePage";
import { AccountPage } from "./pages/Account/AccountPage";
import { UserState } from "./context/user-context/userState";
import { Footer } from "./components/Footer";
import { FullStoryProvider } from "@fullstory/react-library";

function App() {
    return (
        <UserState>
            <div>
                <FullStoryProvider pageCaptureRules={{ account: ["url"], documents: ["none"] }}>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/account" element={<AccountPage />} />
                        <Route path="/documents" element={<AccountPage />} />
                        <Route path="/transfer" element={<AccountPage />} />
                    </Routes>
                </FullStoryProvider>
                <Footer />
            </div>
        </UserState>
    );
}

export default App;
